import { Form } from "antd";
import { TbGavel, TbLock, TbMessages, TbShieldCheck } from "react-icons/tb";
import { applyPurposePreset, StrategyFormValues, StrategyPurpose } from "../functions";
import { ChoiceCards, StepHeading } from "./ui";

const PurposeStep = () => {
  const form = Form.useFormInstance<StrategyFormValues>();

  return (
    <>
      <StepHeading
        step={1}
        title="What’s the goal of this strategy?"
        description="This decides how the plan is presented to creditors and the customer, and sets sensible defaults for the next steps."
      />
      <Form.Item name="purpose" noStyle>
        <ChoiceCards<StrategyPurpose>
          onChange={(purpose) => applyPurposePreset(form, purpose)}
          options={[
            {
              value: "settlement",
              title: "Settlement",
              description: "Pay creditors an agreed, reduced amount to close out the debt.",
              icon: <TbShieldCheck />,
            },
            {
              value: "negotiate",
              title: "restructure",
              description:
                "Work out new terms with creditors — lower payments or interest — while the full debt is repaid.",
              icon: <TbMessages />,
            },
            {
              value: "lawsuit",
              title: "Lawsuit",
              description:
                "Resolve active lawsuits: commission is charged per lawsuit and creditors are paid directly.",
              icon: <TbGavel />,
            },
          ]}
        />
      </Form.Item>

      <div className="flex gap-3 items-start mt-5 px-3.5 py-3 bg-gray-50 border border-solid border-gray-200 rounded-lg">
        <TbLock className="text-violet-700 shrink-0 mt-0.5" size={18} />
        <div className="text-[13px] text-gray-700 leading-relaxed">
          <strong className="font-semibold">Format is set to Manager approval.</strong>
        </div>
      </div>
    </>
  );
};

export default PurposeStep;
